import React from 'react';

import tests from '../../helpers/tests';

import Types from '../../modules/types';

const { viewerIsNotThehiveRsAdminNorAbdul } = tests;

export default [
  'PageSingle',
  {
    path: '/settings/permissions',
    title: 'Permissions',
    headerTitle: 'Permissions',
    renderHeaderTitle: () => 'Permissions',
    hidden: false,
    activity: 'edit',
    url: '/settings/permissions',
    redirect: [['redirect.unauthorized']],
    actions: [['ActionSave', {
      handleSuccess: () => window?.location?.reload(),
    }]],
    skip: [viewerIsNotThehiveRsAdminNorAbdul],
    fields: [
      ['FieldTitle', {
        title: 'Groups',
        // eslint-disable-next-line max-len
        subtitle: 'Top level permissions deciding which side menu items are available to users',
      }],
      ...Types.PERMISSIONS
      .filter(key => Types.PERMISSIONS_MAP[key].type === 'GROUP')
      .map((key) => (['FieldConnectionSelect', {
        name: key,
        label: Types.PERMISSIONS_MAP[key].label,
        url: '/users',
        // placeholder: 'Users',
        allowClear: true,
        mode: 'multiple',
        searchPaths: ['name', 'email'],
        searchPreviewMatchesInLabel: false,
        getChoiceLabel: (item) => (
          <div>
            <div>{item?.name}</div>
            <div
              style={{
                fontSize: '10px',
                lineHeight: '10px',
              }}
            >
              {item?.email}
            </div>
          </div>
        ),
        getExtraQueryConditions: () => ([{
          role: 'ADMIN',
          email: {
            NIN: [
              'admin@packman-shop-server.com',
              ...tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
              ...tests.viewerIsNotAdminWithEmail.PACKMAN_C_SUITE_EMAILS,
            ],
          },
        }]),
      }])),

      ['FieldTitle', {
        title: 'Features',
        // eslint-disable-next-line max-len
        subtitle: 'Permissions deciding which features are available to users',
      }],
      ...Types.PERMISSIONS
      .filter(key => Types.PERMISSIONS_MAP[key].type === 'FEATURE')
      .map((key) => (['FieldConnectionSelect', {
        name: key,
        label: Types.PERMISSIONS_MAP[key].label,
        url: '/users',
        // placeholder: 'Users',
        allowClear: true,
        mode: 'multiple',
        searchPaths: ['name', 'email'],
        getChoiceLabel: (item) => (
          <div>
            <div>{item.name}</div>
            <div
              style={{
                fontSize: '10px',
                lineHeight: '10px',
              }}
            >
              {item.email}
            </div>
          </div>
        ),
        getExtraQueryConditions: () => ([{
          role: 'ADMIN',
          email: {
            NIN: [
              'admin@packman-shop-server.com',
              ...tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
              ...tests.viewerIsNotAdminWithEmail.PACKMAN_C_SUITE_EMAILS,
            ],
          },
        }]),
      }])),
    ],
  },
];
